export const EMPTY_KEY = '__empty__';

export const MULTI_SELECT_FIELDS = ['job_title', 'department', 'company', 'account_status'];

export const HAS_USER_OPTIONS = [
  { value: 'true', label: 'Sí' },
  { value: 'false', label: 'No' },
];

const cleanText = (value) => (
  value === null || value === undefined ? '' : String(value).trim().replace(/\s+/g, ' ')
);

export const normalizeKey = (value) => {
  const text = cleanText(value).toLowerCase();
  return (text === '' || text === '-') ? EMPTY_KEY : text;
};

export const buildOptions = (users, field) => {
  const labels = new Map();
  let hasEmpty = false;

  users.forEach((user) => {
    const key = normalizeKey(user[field]);
    if (key === EMPTY_KEY) {
      hasEmpty = true;
    } else if (!labels.has(key)) {
      labels.set(key, cleanText(user[field]));
    }
  });

  const options = Array.from(labels, ([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }));

  if (hasEmpty) {
    options.push({ value: EMPTY_KEY, label: '(Vacío)' });
  }
  return options;
};

export const buildFilterOptions = (users) => {
  const filterOptions = { has_user: HAS_USER_OPTIONS };
  MULTI_SELECT_FIELDS.forEach((field) => {
    filterOptions[field] = buildOptions(users, field);
  });
  return filterOptions;
};

const matchesFilter = (user, node) => {
  if (Array.isArray(node.value)) {
    if (!node.value.length) return true;
    if (node.id === 'has_user') {
      return node.value.includes(String(!!user.has_user));
    }
    return node.value.includes(normalizeKey(user[node.id]));
  }

  const value = (node.value || '').toString().trim().toLowerCase();
  if (value.length <= 1) return true;
  return (user[node.id] || '').toString().toLowerCase().includes(value);
};

export const applyFilters = (users, filtered) => {
  if (!filtered || !filtered.length) return users;
  return users.filter((user) => filtered.every((node) => matchesFilter(user, node)));
};
